"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var victory_1 = require("victory");
var AccordionSummary_1 = __importDefault(require("atomicComponents/atoms/Accordion/AccordionSummary"));
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var Accordion2_1 = __importDefault(require("shared/components/Accordion2"));
var AccordionDetails_1 = __importDefault(require("shared/components/Accordion2/AccordionDetails"));
var plansBenchmarks = [
    {
        name: 'Business Plan',
        subPlans: [
            {
                name: 'Annual',
                min: 6.2,
                median: 6.8,
                max: 9.6,
                n: 34,
            },
            {
                name: 'Monthly',
                min: 11.9,
                median: 12,
                max: 12.1,
                n: 21,
            },
        ],
    },
];
var BenchmarksAccordion = function (_a) {
    var serviceStat = _a.serviceStat;
    return ((0, jsx_runtime_1.jsxs)(Accordion2_1.default, { children: [(0, jsx_runtime_1.jsx)(AccordionSummary_1.default, __assign({ iconSize: "sm", sx: { py: 0, mb: 0.5 } }, { children: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: serviceStat.service }) })) })), (0, jsx_runtime_1.jsx)(AccordionDetails_1.default, { children: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(victory_1.VictoryBoxPlot, { horizontal: true, data: plansBenchmarks.map(function (planGroup, idx) { return planGroup.subPlans.map(function (plan) { return ({
                            x: idx + 1,
                            min: plan.min,
                            median: plan.median,
                            max: plan.max,
                            q1: plan.min,
                            q3: plan.max,
                        }); }); }).flat() }) })) })] }));
};
exports.default = BenchmarksAccordion;
